import React from "react";
import { motion } from "framer-motion";
import BulletPoint from "./BulletPoint.jsx";

const IITM = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, delay: 0.1 }}
      className="w-full"
    >
      {/* JOB TITLE & COMPANY */}
      <div className="flex text-white flex-wrap gap-1 font-medium text-xl font-titleFont flex-col sml:flex-row">
        <h3>Research Intern</h3>
        <a
          href="https://www.iitm.ac.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text-sm mt-1 font-medium text-textGreen flex">
            @IIT Madras
          </span>
        </a>
      </div>
      {/* Working Dates */}
      <p className="pt-3 text-white">May 2025 - July 2025</p>
      {/* INTRODUCTION */}
      {/* <p className="mt-3 text-base font-light flex gap-2 text-textDark">
        <strong>
          Actively reviewed a comprehensive Node.js book covering beginner to
          advanced topics. Focused on enhancing the material by integrating
          practical suggestions and relevant real-world examples.
        </strong>
      </p> */}
      {/* Bullet Points */}
      <ul className="mt-4 flex flex-col gap-3 text-textDark">
        <BulletPoint
          headningText="EduBench - Responsible AI Framework"
          contentText="Designed a persona-driven Responsible AI safety framework (EduBench), aligned with global AI policy standards, enabling context-aware governance across 9 education-specific risk domains in the Indian ecosystem."
        />
        <BulletPoint
          headningText="Multi-Model Safety Evaluation"
          contentText="Integrated multi-model evaluation and persona-specific harm perspectives, improving safety assessment robustness by 28% and evaluation accuracy by 20%."
        />
        <BulletPoint
          headningText="Systematic Safety Testing"
          contentText="Conducted systematic safety testing across diverse user personas to identify ethical risks and governance gaps in educational AI systems."
        />
      </ul>
    </motion.div>
  );
};

export default IITM;
